export const fullPhoneRegex = /^\d{11}$/
